import React, {useEffect, useState} from "react";
import "./Notif.scss";
import SwiperId from "react-id-swiper";
import SimpleLineIcon from "react-simple-line-icons";
import {useHistory} from "react-router";
import {MessageData, MessageSeen, TopicData} from "./NotifServices";
import {Collapse} from 'react-collapse';
import moment from "moment-jalaali";
import useWindowDimensions from "../../hooks/useWindowDimensions";



const ConvertToJalali = (date) =>{
    // console.log("Data : ",date)
    if(date){
        return  moment.utc(date.split('+')[0]).format('jYYYY-jMM-jDD HH:mm');
    }
    return ""
}

function Notif() {

    //hooks
    let history = useHistory();

    //states
    const [last,setLast] = useState([])
    const [messages,setMessages] = useState([])

    // const params = {
    //     slidesPerView: 3,
    //     spaceBetween: 5,
    //     pagination: {
    //         el: '.swiper-pagination',
    //         clickable: true
    //     }
    // }

    useEffect(()=>{
        getLast().then();
        getMessages().then();
    },[])

    const getLast = async () =>{
        const topics = await TopicData();
        setLast(topics.data)
        // console.log("topics : ", topics);
    }

    const getMessages = async () =>{
        const messages = await MessageData();
        setMessages(messages.data.results)
        // console.log("messages : ", messages);
    }

    const sliderCalc = (count)=>{
        if(count===1){return 1}
        if(count===2){return 2}
        if(count>2){return 3}
    }


    const NotifCard =  ({mes})=>{

        const [open,set_open] = useState(false)
        const [seen,set_seen] = useState(mes.is_seen)
        const viewNotif = ()=>{
            set_open(!open)
            set_seen(true)
            if(!seen){
                seenApi()
            }
        }

        const seenApi = async ()=>{
            try{
                const res = await MessageSeen(mes.uid)
            }catch (e) {
                console.log(e)
            }
        }

        return(
            <div className="notif-item" >
                <div className={seen?"notif-item-body notif-item-seen":"notif-item-body notif-item-not-seen"} onClick={viewNotif}>
                    <div className="notif-item-body-date">
                        <span style={{fontSize:12}}>{ConvertToJalali(mes.created)}</span>
                    </div>

                    <div className="logo-wrapper" >
                        <div className="notif-item-body-info">
                            {mes.message.title?<span>{mes.message.title}</span>:null}
                            {mes.message.merchant_name?<span className="notif-item-tin">{mes.message.merchant_name}</span>:null}
                        </div>
                        <img src={mes.message.merchant_thumbnail} alt=""/>
                    </div>
                </div>

                <Collapse isOpened={open}>
                    {mes.message.file_type===0 || mes.message.file_type===4?<div className="notif-item-header">
                        {mes.message.file?<img src={mes.message.file} alt=""/>:null}
                    </div>:null}
                    {mes.message.file_type===1?<div className="notif-item-header">
                        <video controls>
                            <source src={mes.message.file} type="video/mp4"/>
                        </video>
                    </div>:null}
                    <div className="notif-item-body">
                        {/*{mes.message.title?<span>{mes.message.title}</span>:null}*/}
                        <p>{mes.body}</p>
                    </div>
                    <div className="notif-item-footer">
                        <div className="notif-item-footer-item notif-item-footer-item-message" onClick={()=>{
                            let merId = mes.message.topic.split(":")[2];
                            history.push(`/chat/${mes.message.topic}`,{merchant:
                                    {uid:merId, name:mes.message.merchant_name, topic:mes.message.topic}
                            })
                        }}>
                            <span>ارسال پیام</span>
                            <SimpleLineIcon name="speech"/>
                        </div>
                        <div className="notif-item-footer-item">
                            <span>{mes.message.merchant_name}</span>
                            <img src={mes.message.merchant_thumbnail} alt=""/>
                        </div>
                    </div>
                </Collapse>
            </div>
        )
    }

    const { height, width,mobileWidth } = useWindowDimensions();

    return(
        <div className="notif-container">
            <div className="customer-header" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}} >
                <span>اعلان ها و پیام ها</span>
                <i onClick={()=>{
                    // history.goBack();
                    history.push("/home")
                }}
                   className="fa fa-arrow-right"></i>
            </div>

            {/*<div className="notif-last-visit">*/}
            {/*    <div className="notif-last-visit-titre">*/}
            {/*        <span>پیام ها</span>*/}
            {/*    </div>*/}

            {/*    <div className="notif-last-visit-list">*/}


            {/*        {last.length>0?<SwiperId { ...{*/}
            {/*            slidesPerView: sliderCalc(last.length),*/}
            {/*            spaceBetween: 5,*/}
            {/*            pagination: {*/}
            {/*                el: '.swiper-pagination',*/}
            {/*                clickable: true*/}
            {/*            }*/}
            {/*        }}>*/}
            {/*            {last && last.map(item=>{*/}
            {/*                return(*/}

            {/*                    <div className="notif-last-visit-item" onClick={()=>{*/}
            {/*                        let merchantId = item.topic.split(":")[2];*/}
            {/*                        history.push(`/chat/${item.topic}`,*/}
            {/*                            {merchant: {uid:merchantId, name:item.title, topic:item.topic}*/}
            {/*                            })*/}
            {/*                    }}>*/}
            {/*                        <img src={item.image} />*/}
            {/*                        <span>{item.title}</span>*/}
            {/*                    </div>*/}
            {/*                )*/}
            {/*            })}*/}
            {/*            /!*<div className="notif-last-visit-message">*!/*/}
            {/*            /!*    <div className="plus-wrapper">*!/*/}
            {/*            /!*        <img src="/svg/pluse_icon.svg" alt="plus"/>*!/*/}
            {/*            /!*    </div>*!/*/}
            {/*            /!*    <span>پیام جدید</span>*!/*/}
            {/*            /!*</div>*!/*/}
            {/*        </SwiperId>:null}*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="notif-list-sec">
                <div className="notif-last-visit-titre">
                    <span>اعلان ها</span>
                </div>

                <div className="notif-list">

                    {messages && messages.map(mes=>{
                        return(
                            <NotifCard mes={mes}/>
                        )
                    })}


                </div>



            </div>


        </div>
    )
}


export {Notif};
